import React, { useState } from 'react';
import { OutputStockChart } from './index';
import SubTabNav from '../common/SubTabNav';

interface OutputChartContainerProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  className?: string;
  syncGroup?: string;
  activeSubTab?: 'shift' | 'day' | 'week';
  onActiveSubTabChange?: (tab: 'shift' | 'day' | 'week') => void;
}

const OutputChartContainer: React.FC<OutputChartContainerProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  className = '',
  syncGroup,
  activeSubTab,
  onActiveSubTabChange
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<'shift' | 'day' | 'week'>('shift');
  
  // Use external state if provided, otherwise use internal state
  const activeTab = activeSubTab !== undefined ? activeSubTab : internalActiveTab;
  const setActiveTab = onActiveSubTabChange || setInternalActiveTab;

  const tabs = [
    { key: 'shift', label: 'per Shift' },
    { key: 'day', label: 'per Day' },
    { key: 'week', label: 'per Week' }
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Subtab navigation */}
      <SubTabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) => setActiveTab(tab as 'shift' | 'day' | 'week')}
      />

      {/* Output Stock Chart without its own navigation */}
      <OutputStockChart 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        syncGroup={syncGroup}
        activeTab={activeTab}
        onActiveTabChange={setActiveTab}
        hideSubTabNav={true}
        className="space-y-0" // Remove extra spacing since we have nav above
      />
    </div>
  );
};

export default OutputChartContainer;
